export default {
    process: function (newNodeType, nodeModel, parentNode) {
        if (newNodeType === "WINDOW" && parentNode) {
            nodeModel.metaObject.autoProperties = nodeModel.metaObject.autoProperties || {};

            if (parentNode.metaObject.type === "STREAM") {
                nodeModel.metaObject.autoProperties.stream = parentNode.metaObject.id;
            }
        }
    },
};
